import { render, staticRenderFns } from "./jobPostings.vue?vue&type=template&id=b760791c&scoped=true&"
import script from "./jobPostings.vue?vue&type=script&lang=js&"
export * from "./jobPostings.vue?vue&type=script&lang=js&"
import style0 from "./jobPostings.vue?vue&type=style&index=0&id=b760791c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b760791c",
  null
  
)

export default component.exports